import { render, staticRenderFns } from "./VogelsEntry.vue?vue&type=template&id=2c0c5ecc&"
import script from "./VogelsEntry.vue?vue&type=script&lang=js&"
export * from "./VogelsEntry.vue?vue&type=script&lang=js&"
import style0 from "./VogelsEntry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports